// Wer ohne Betreiber-Rolle auf einer Betriebsseite landet (Lesezeichen,
// Support-Zugriff), sieht einen Hinweis statt leerer Formulare.

import { Sym } from "../../components/social-ui";
import { EmptyState, Page, PageHeader } from "../../components/ui";
import { supportSitzung } from "../../api";

export function NurBetreiber({ titel }: { titel: string }): JSX.Element {
  const support = supportSitzung();
  return (
    <Page className="max-w-5xl">
      <PageHeader eyebrow="Betrieb" title={titel} />
      <div className="card p-2">
        <EmptyState
          icon={<Sym name="shield" className="h-5 w-5" />}
          title="Diese Seite ist dem Betreiber vorbehalten."
          description={support
            ? "Du bist gerade im Support-Zugriff bei einem Radio. Beende ihn oben im Band, um zurück in deine eigene Sitzung zu kommen."
            : "Hier verwaltet der Betreiber der Installation alle Radios, Tarife und die Nutzung."}
        />
      </div>
    </Page>
  );
}
